import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import Box from './Box';
import Toast from './Toast';
import axios from 'axios';
import Tools from './Tools';
import { Chart } from "react-google-charts";
import userEvent from '@testing-library/user-event';
import Popover from './ui/Popover';
import { ArrowRight as ArrowRightIcon } from './icons/svgIcons';

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';
import '../components/css/Reports.css';


const Reports = (props) => {

    const history = useHistory();

    const [data, setData] = useState({});
    const [toastRef, setToastRef] = useState(React.createRef());
    const [companies, setCompanies] = useState([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);
    const [checkedMachineTasks, setCheckedMachineTasks] = useState([]);
    const [checkedTaskTypes, setCheckedTaskTypes] = useState([]);
    const [includeHangedCalls, setIncludeHangedCalls] = useState(false);
    const [popupCampaignId, setPopupCampaignId] = useState(null);
    const [dataGroupedByContactType, setDataGroupedByContactType] = useState([]);
    const [chartTaskTypeData, setChartTaskTypeData] = useState([]);
    const [selectedDayRange, setSelectedDayRange] = useState({ from: null, to: null });
    const [checkedPendings, setCheckedPendings] = useState(false);


    useEffect(() => {
        if (!sessionStorage.getItem('sessionData')) {
            history.push('/login');
        } else {
            
            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/companies`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                params: {}
            };
            axios(options).then(response => {
                setCompanies(response.data);
            })
            .catch(function (error) {
                console.log("Error:", error.message);
                setError(error.message);
            });
        }
    }, []);


    useEffect(()=>{
        if (data.campaignId){
            getDailyTaskReport()
        }
    }, [data]);

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const handleCalendar = (dateValue, fieldName) => {
        setData({ ...data, [fieldName]: dateValue})
    }

    const filterByCampaign=(campaignId)=>{
        setData({ ...data, ['campaignId']: campaignId });
    }

    const customLocaleSpanish = {
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',],

        weekDays: [{ name: 'Lunes', short: 'L', }, { name: 'Martes', short: 'M', }, { name: 'Miércoles', short: 'M', }, { name: 'Jueves', short: 'J', }, { name: 'Viernes', short: 'V', }, { name: 'Sábado', short: 'S', isWeekend: true, }, { name: 'Domingo', short: 'D', isWeekend: true, },],
        weekStartingIndex: 6,
        getToday(gregorainTodayObject) {
            return gregorainTodayObject;
        },

        toNativeDate(date) {
            return new Date(date.year, date.month - 1, date.day);
        },

        getMonthLength(date) {
            return new Date(date.year, date.month, 0).getDate();
        },

        transformDigit(digit) {
            return digit;
        },

        // texts in the date picker
        nextMonth: 'Próximo mes',
        previousMonth: 'Mes anterior',
        openMonthSelector: 'Selector de mes',
        openYearSelector: 'Selector de año',
        closeMonthSelector: 'Cerrar selector de mes',
        closeYearSelector: 'Cerrar selector de año',
        defaultPlaceholder: 'Seleccionar...',

        // for input range value
        from: 'Del',
        to: 'al',


        // used for input value when multi dates are selected
        digitSeparator: ',',

        // if your provide -2 for example, year will be 2 digited
        yearLetterSkip: 0,

        // is your language rtl or ltr?
        isRtl: false,
    }


    const downloadDetail=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

        data.selectedDayRange = selectedDayRange;
        let serviceParams=data;
        if (checkedMachineTasks.length > 0){ 
            serviceParams.machineTasksTypes = checkedMachineTasks;
        } else {
            serviceParams.machineTasksTypes = undefined;
        }
        if (checkedTaskTypes.length > 0) {
            serviceParams.executiveTaskTypes = checkedTaskTypes; 
        } else{
            serviceParams.executiveTaskTypes = undefined; 
        }

        serviceParams.includeHangedCalls = includeHangedCalls;
        serviceParams.checkedPendings = checkedPendings;

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/dailyTasksDownload`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token,
            },
            params: serviceParams
        };

        setLoading(true);
        axios(options).then(response => {
            setLoading(false);
            
            let csv = 'data:text/csv;charset=utf-8,' + response.data;
            let csvData = encodeURI(csv);
            window.open(csvData);

        });
    }

    const getDailyTaskReport=()=>{
        data.selectedDayRange = selectedDayRange;
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/daily_tasks`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token,
            },
            params: data
        };

        setLoading(true);
        axios(options).then(response => {
            setLoading(false);
            setReportData(response.data);
            

            const header = [["Tipo Contacto", "Total"]];
            
            let dataGroupedByContactType = [];
            response.data.executiveTasks.forEach(function (et) {
                let found = dataGroupedByContactType.find((item) => item.desc && (item.desc === et.CT_DETAILS.desc));
                if (!found) {
                    let objCT = { desc: et.CT_DETAILS.desc, count: et.count, tt: [] }
                    let objTT = { type: 'E', id: et.TT_DETAILS._id, desc: et.TT_DETAILS.desc, count: et.count }
                    objCT.tt.push(objTT);

                    dataGroupedByContactType.push(objCT);
                } else {
                    let foundIndex = dataGroupedByContactType.findIndex((item) => item.desc === et.CT_DETAILS.desc);
                    let objCT = { desc: et.CT_DETAILS.desc, count: Number(found.count) + Number(et.count), tt: found.tt }
                    let objTT = { type: 'E', id: et.TT_DETAILS._id, desc: et.TT_DETAILS.desc, count: et.count }
                    objCT.tt.push(objTT);

                    dataGroupedByContactType[foundIndex] = objCT;
                }
            });



            let countMachineTasks=0;
            let arrMTTT=[];

            if (response.data.machineTasks.length>0){
                response.data.machineTasks.forEach(task => {
                    let objTT = { type: 'M', id: task._id, desc: task.ACS_DETAILS.translation + ' ('+task._id+')', count: task.count };
                    arrMTTT.push(objTT);
                    countMachineTasks += task.count;
                });
            }

            if (response.data.hangedCalls>0){
                countMachineTasks += response.data.hangedCalls;
                let objTT = { type: 'M', id:'HANGEDCALLS', desc: "Corta Llamado", count: response.data.hangedCalls };
                arrMTTT.push(objTT);
            }


            let objCT = { desc: "Gestion máquina", count: countMachineTasks, tt: arrMTTT };
            dataGroupedByContactType.push(objCT);
            setDataGroupedByContactType(dataGroupedByContactType);


            if (response.data.pendingOfProcess) {
                let objCT = { desc: "Sin Gestión", count: response.data.pendingOfProcess, tt: [] };
                let objTT = { type: 'N', id: "SIN_GESTION", desc: "Sin Gestión", count: response.data.pendingOfProcess }
                objCT.tt.push(objTT);
                dataGroupedByContactType.push(objCT);
            }



            //build structure for chart
            let chartValues=[];
            dataGroupedByContactType.forEach(element => {
                chartValues.push([element.desc, element.count]);
            });

            setChartTaskTypeData([...header, ...chartValues]);
        });
    }

    

    const handleCheckMachineTask = (event) => {
        let updatedList = [...checkedMachineTasks];
        if (event.target.checked) {
            updatedList = [...checkedMachineTasks, event.target.value];
        } else {
            updatedList.splice(checkedMachineTasks.indexOf(event.target.value), 1);
        }
        setCheckedMachineTasks(updatedList);
    };

    const handleCheckTaskType = (event) => {
        let updatedList = [...checkedTaskTypes];
        if (event.target.checked) {
            updatedList = [...checkedTaskTypes, event.target.value];
        } else {
            updatedList.splice(checkedTaskTypes.indexOf(event.target.value), 1);
        }
        setCheckedTaskTypes(updatedList);
    };

    const handleCheckPending = (event) => {
        setCheckedPendings(event.target.checked);
    };

    const chartOptions = {
        legend: "none",
        theme: 'maximized',
        is3D: true,
        fontName: 'Roboto',
        backgroundColor:getComputedStyle(document.documentElement).getPropertyValue('--mainBg').trim(),
        colors: ['#F66548', '#5FC750', '#FFC23A', '#1DBABA', '#D4427A', '#FD9332', '#49A9E5', '#A3A3A3']
    };

    return (
        <div className="mainWrapper">
            <Toast ref={toastRef}></Toast>
            <Sidebar key={props.inboundConnectedQueues} />
            

            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Reportes de gestión</h1>
                        <span className="upper">Reportes</span>
                    </div>
                    <div className="flexWrapper"> 
                        <UserMenu/>
                    </div>
                </div>

                <h3>REPORTE GESTIONES DIARIAS</h3>
                <div className="flexRow">
                    <div className="flexCol">
                        <Box type="select" name="companyId" className="x4" label="Empresa" placeholder="Seleccione ..." options={companies} onChange={handleChange} required></Box>
                        <div className="inputWrapper x3">
                            <label className="required">Fecha</label>
                            <DatePicker
                                value={selectedDayRange}
                                onChange={setSelectedDayRange}
                                inputPlaceholder="Filtro fechas"
                                locale={customLocaleSpanish}
                                shouldHighlightWeekends
                            />
                        </div>

                        <button className={loading ? 'default collapsed loading' : 'default collapsed'} onClick={getDailyTaskReport}>Generar reporte</button>
                    </div>
                </div>

                {reportData?(
                    <div>
                        <h3 className='sep'>CAMPAÑAS</h3>
                        {reportData.campaigns.length>0?(
                            <table>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Nombre</th>
                                        <th className='right'>Registros</th>
                                        <th className='right'>Progreso</th>
                                        <th className='right'>Abandonos</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {reportData.campaigns.map((campaign, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{campaign.CMP_DETAILS.type}</td>
                                            <td className='rel'>
                                                <a onClick={() => (campaign.CMP_DETAILS._id === popupCampaignId) ? setPopupCampaignId(null) : setPopupCampaignId(campaign.CMP_DETAILS._id)}><i className='info' /></a>
                                                <Popover show={campaign.CMP_DETAILS._id === popupCampaignId} position="right">
                                                    <dl>
                                                        <dt>Id Campaña</dt>
                                                        <dd>{campaign.CMP_DETAILS._id}</dd>
                                                        <dt>Id Asignación</dt>
                                                        <dd>{campaign.CMP_DETAILS.assignmentId}</dd>
                                                    </dl>
                                                </Popover>
                                                {campaign.CMP_DETAILS.name}
                                            </td>

                                            <td className='right'>{Tools.fmtClNumber(campaign.CMP_DETAILS.itemCount)}</td>
                                            <td className='right'>{campaign.CMP_DETAILS.progress}%</td>
                                            <td className='right'>{campaign.CMP_DETAILS.abandonments}</td>
                                            <td>
                                                
                                                {data.campaignId !== campaign.CMP_DETAILS._id?(
                                                    <button className="link" onClick={() => filterByCampaign(campaign.CMP_DETAILS._id)}>Filtrar</button>    
                                                ) : (
                                                    <button className="link" onClick={() => filterByCampaign('NONE')}>Quitar filtro</button>
                                                )
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            </table>
                        ) : (
                                <p>No hay campañas para el filtro especificado.</p>
                        )}

                        <h3 className='sep'>GESTIONES</h3>
                        <div className="taskInfoWrapper">
                            <div className="detailsWrapper">
                                {dataGroupedByContactType.map((ct, index) => {
                                    return (
                                        <details>
                                            <summary key={index}>
                                                <div className='listDescAndValue'><span><ArrowRightIcon /><span className="bullet" style={{ backgroundColor: chartOptions.colors[index] }}></span>{ct.desc}</span><span>{ct.count}</span></div>
                                            </summary>
                                            {ct.tt.map((tt, index) => {
                                                return (
                                                <div className='listDescAndValue'>
                                                    <span>
                                                        <label>
                                                            {tt.type==='E'?(
                                                                <input value={tt.id} type="checkbox" onChange={handleCheckTaskType} />
                                                            ) : tt.type === 'M'?(
                                                                <input value={tt.id} type="checkbox" onChange={handleCheckMachineTask} />
                                                            ) : tt.type === 'N'?(
                                                                <input value={tt.id} type="checkbox" onChange={handleCheckPending} />
                                                            ):null}
                                                            &nbsp; {tt.desc}
                                                        </label>
                                                    </span>
                                                    <span>{tt.count}</span>
                                                </div>)
                                            })}
                                        </details>
                                    );
                                })}
                            </div>
                            <div className="pieChartWrapper">
                                <Chart
                                    chartType="PieChart"
                                    data={chartTaskTypeData}
                                    options={chartOptions}
                                    width={"100%"}
                                    height={"100%"}
                                />
                            </div>
                        </div>




                        <br/>
                        <div>
                            <p className="debug">data:{JSON.stringify(data)}</p>
                            <p className="debug">checkedMachineTasks:{JSON.stringify(checkedMachineTasks)}</p>
                            <p className="debug">checkedTaskTypes:{JSON.stringify(checkedTaskTypes)}</p>
                            <p className="debug">includeHangedCalls:{JSON.stringify(includeHangedCalls)}</p>
                            <p className="debug">checkedPendings:{JSON.stringify(checkedPendings)}</p>
                        </div>
                        <button className={loading ? 'default loading' : 'default'} onClick={downloadDetail}>Descargar detalle</button>

                    </div>
                ):null}
                
            </div>
            
        </div>
        
    );
    
}

export default Reports;





    